module.exports = __webpack_public_path__ + "fonts/SamsungOne-300_v1.1.96afe50a.ttf";